import { types as productsTypes } from "reducers/products";

export const types = {
    ACCOUNT_AGREEMENTS_REQUEST: "accounts/ACCOUNT_AGREEMENTS_REQUEST",
    ACCOUNT_AGREEMENTS_SUCCESS: "accounts/ACCOUNT_AGREEMENTS_SUCCESS",
    ACCOUNT_DETAILS_REQUEST: "accounts/ACCOUNT_DETAILS_REQUEST",
    ACCOUNT_DETAILS_SUCCESS: "accounts/ACCOUNT_DETAILS_SUCCESS",
    ACCOUNT_DOWNLOAD_STATEMENT_REQUEST: "accounts/ACCOUNT_DOWNLOAD_STATEMENT_REQUEST",
    ACCOUNT_DOWNLOAD_STATEMENT_SUCCESS: "accounts/ACCOUNT_DOWNLOAD_STATEMENT_SUCCESS",
    ACCOUNT_FETCH_MORE_MOVEMENTS_REQUEST: "accounts/ACCOUNT_FETCH_MORE_MOVEMENTS_REQUEST",
    ACCOUNT_FETCH_MORE_MOVEMENTS_SUCCESS: "accounts/ACCOUNT_FETCH_MORE_MOVEMENTS_SUCCESS",
    ACCOUNT_HISTORICAL_BALANCES_REQUEST: "accounts/ACCOUNT_HISTORICAL_BALANCES_REQUEST",
    ACCOUNT_HISTORICAL_BALANCES_SUCCESS: "accounts/ACCOUNT_HISTORICAL_BALANCES_SUCCESS",
    ACCOUNT_HISTORICAL_BALANCES_FAILURE: "accounts/ACCOUNT_HISTORICAL_BALANCES_FAILURE",
    ACCOUNT_MOVEMENT_DETAILS_REQUEST: "accounts/ACCOUNT_MOVEMENT_DETAILS_REQUEST",
    ACCOUNT_MOVEMENT_DETAILS_SUCCESS: "accounts/ACCOUNT_MOVEMENT_DETAILS_SUCCESS",
    CLEAN_ACCOUNT_MOVEMENTS: "accounts/CLEAN_ACCOUNT_MOVEMENTS",
    ACCOUNT_READ_REQUEST: "accounts/ACCOUNT_READ_REQUEST",
    ACCOUNT_READ_SUCCESS: "accounts/ACCOUNT_READ_SUCCESS",
    ACCOUNT_READ_QR_REQUEST: "accounts/ACCOUNT_READ_QR_REQUEST",
    ACCOUNT_READ_QR_SUCCESS: "accounts/ACCOUNT_READ_QR_SUCCESS",
    CLOSE_OPTIONS: "accounts/CLOSE_OPTIONS",
    DOWNLOAD_HISTORICAL_BALANCES_REQUEST: "accounts/DOWNLOAD_HISTORICAL_BALANCES_REQUEST",
    DOWNLOAD_HISTORICAL_BALANCES_FAILURE: "accounts/DOWNLOAD_HISTORICAL_BALANCES_FAILURE",
    DOWNLOAD_HISTORICAL_BALANCES_SUCCESS: "accounts/DOWNLOAD_HISTORICAL_BALANCES_SUCCESS",
    DOWNLOAD_MOVEMENTS_REQUEST: "accounts/DOWNLOAD_MOVEMENTS_REQUEST",
    DOWNLOAD_MOVEMENTS_FAILURE: "accounts/DOWNLOAD_MOVEMENTS_FAILURE",
    DOWNLOAD_MOVEMENTS_SUCCESS: "accounts/DOWNLOAD_MOVEMENTS_SUCCESS",
    DOWNLOAD_PENDING_MOVEMENTS_REQUEST: "accounts/DOWNLOAD_PENDING_MOVEMENTS_REQUEST",
    DOWNLOAD_PENDING_MOVEMENTS_FAILURE: "accounts/DOWNLOAD_PENDING_MOVEMENTS_FAILURE",
    DOWNLOAD_PENDING_MOVEMENTS_SUCCESS: "accounts/DOWNLOAD_PENDING_MOVEMENTS_SUCCESS",
    DOWNLOAD_ACCOUNTS_REQUEST: "accounts/DOWNLOAD_ACCOUNTS_REQUEST",
    DOWNLOAD_ACCOUNTS_FAILURE: "accounts/DOWNLOAD_ACCOUNTS_FAILURE",
    DOWNLOAD_ACCOUNTS_SUCCESS: "accounts/DOWNLOAD_ACCOUNTS_SUCCESS",
    EDIT_MOVEMENT_NOTE_REQUEST: "accounts/EDIT_MOVEMENT_NOTE_REQUEST",
    LIST_ACCOUNT_STATEMENTS_REQUEST: "accounts/LIST_ACCOUNT_STATEMENTS_REQUEST",
    LIST_ACCOUNT_STATEMENTS_SUCCESS: "accounts/LIST_ACCOUNT_STATEMENTS_SUCCESS",
    LIST_ACCOUNTS_REQUEST: "accounts/LIST_ACCOUNTS_REQUEST",
    LIST_ACCOUNTS_SUCCESS: "accounts/LIST_ACCOUNTS_SUCCESS",
    LIST_ACCOUNTS_FAILURE: "accounts/LIST_ACCOUNTS_FAILURE",
    LIST_ACCOUNTS_CBU_REQUEST: "accounts/LIST_ACCOUNTS_CBU_REQUEST",
    LIST_ACCOUNTS_CBU_SUCCESS: "accounts/LIST_ACCOUNTS_CBU_SUCCESS",
    LIST_ALL_ACCOUNTS_REQUEST: "accounts/LIST_ALL_ACCOUNTS_REQUEST", // incluye las cuentas BiBank 090 y 093
    RESET_FILTERS: "accounts/RESET_FILTERS",
    SET_MOBILE_FILTER: "accounts/SET_MOBILE_FILTER",
    SET_SELECTED_ACCOUNT: "accounts/SET_SELECTED_ACCOUNT",
    SET_SELECTED_MOVEMENT: "accounts/SET_SELECTED_MOVEMENT",
    SET_UNIQUE_ACCOUNT: "accounts/SET_UNIQUE_ACCOUNT",
    TOGGLE_OPTIONS: "accounts/TOGGLE_OPTIONS",
    ACCOUNT_FETCH_MOVEMENTS_REQUEST: "accounts/ACCOUNT_FETCH_MOVEMENTS_REQUEST",
    ACCOUNT_FETCH_MOVEMENTS_SUCCESS: "accounts/ACCOUNT_FETCH_MOVEMENTS_SUCCESS",
    ACCOUNT_FETCH_MOVEMENTS_STATES_REQUEST: "accounts/ACCOUNT_FETCH_MOVEMENTS_STATES_REQUEST",
    ACCOUNT_FETCH_MOVEMENTS_STATES_SUCCESS: "accounts/ACCOUNT_FETCH_MOVEMENTS_STATES_SUCCESS",
    ACCOUNT_SUMMARY_FILTER: "accounts/ACCOUNT_SUMMARY_FILTER",
    MOVEMENTS_SUMMARY_FILTER: "accounts/MOVEMENTS_SUMMARY_FILTER",
    ACCOUNT_GET_YEARS_MONTH_SUMMARY_REQUEST: "accounts/ACCOUNT_GET_YEARS_MONTH_SUMMARY_REQUEST",
    ACCOUNT_GET_YEARS_MONTH_SUMMARY_SUCCESS: "accounts/ACCOUNT_GET_YEARS_MONTH_SUMMARY_SUCCESS",
    SET_NEW_AGREEMENT: "accounts/SET_NEW_AGREEMENT",
    NEW_AGREEMENT_SHOW: "accounts/NEW_AGREEMENT_SHOW",
    CLEAN_NEW_AGREEMENT_TICKET: "accounts/CLEAN_NEW_AGREEMENT_TICKET",
    AGREEMENT_AVAILABLE_AMOUNT_REQUEST: "accounts/AGREEMENT_AVAILABLE_AMOUNT_REQUEST",
    AGREEMENT_TAX_REQUEST: "accounts/AGREEMENT_TAX_REQUEST",
    AGREEMENT_TAX_SUCCESS: "accounts/AGREEMENT_TAX_SUCCESS",
    AGREEMENT_AVAILABLE_AMOUNT_SUCCESS: "accounts/AGREEMENT_AVAILABLE_AMOUNT_SUCCESS",
    NEW_AGREEMENT_TICKET_REQUEST: "accounts/NEW_AGREEMENT_TICKET_REQUEST",
    NEW_AGREEMENT_TICKET_SUCCESS: "accounts/NEW_AGREEMENT_TICKET_SUCCESS",
    SET_NEW_ACCOUNT_DATA: "accounts/SET_NEW_ACCOUNT_DATA",
    ACCOUNT_TICKET_CREDENTIAL_REQUEST: "accounts/ACCOUNT_TICKET_CREDENTIAL_REQUEST",
    ACCOUNT_TICKET_CREDENTIAL_SUCCESS: "accounts/ACCOUNT_TICKET_CREDENTIAL_SUCCESS",
    NEW_ACCOUNT_DATA_SHOW: "accounts/NEW_ACCOUNT_DATA_SHOW",
    NEW_ACCOUNT_TICKET_REQUEST: "accounts/NEW_ACCOUNT_TICKET_REQUEST",
    NEW_ACCOUNT_TICKET_SUCCESS: "accounts/NEW_ACCOUNT_TICKET_SUCCESS",
    SET_NEW_ACCOUNT_SIGNING: "accounts/SET_NEW_ACCOUNT_SIGNING",
    CLEAN_NEW_ACCOUNT_TICKET: "accounts/CLEAN_NEW_ACCOUNT_TICKET",
    SIGN_ACCOUNT_TICKET_REQUEST: "accounts/SIGN_ACCOUNT_TICKET_REQUEST",
    SIGN_ACCOUNT_TICKET_SUCCESS: "accounts/SIGN_ACCOUNT_TICKET_SUCCESS",
    CHANGE_CBU_ALIAS_REQUEST: "accounts/CHANGE_CBU_ALIAS_REQUEST",
    CHANGE_CBU_ALIAS_SUCCESS: "accounts/CHANGE_CBU_ALIAS_SUCCESS",
    CHANGE_CBU_ALIAS_FAILURE: "accounts/CHANGE_CBU_ALIAS_FAILURE",
    DOWNLOAD_MOVEMENT_REQUEST: "accounts/DOWNLOAD_MOVEMENT_REQUEST",
    DOWNLOAD_MOVEMENT_FAILURE: "accounts/DOWNLOAD_MOVEMENT_FAILURE",
    DOWNLOAD_MOVEMENT_SUCCESS: "accounts/DOWNLOAD_MOVEMENT_SUCCESS",
    FILTER_BALANCES_REQUEST: "accounts/FILTER_BALANCES_REQUEST",

    ACCOUNT_FETCH_AGREEMENTS_REQUEST: "accounts/ACCOUNT_FETCH_AGREEMENTS_REQUEST",
    ACCOUNT_FETCH_AGREEMENTS_STATES_REQUEST: "accounts/ACCOUNT_FETCH_AGREEMENTS_STATES_REQUEST",
    ACCOUNT_FETCH_MORE_AGREEMENTS_REQUEST: "accounts/ACCOUNT_FETCH_MORE_AGREEMENTS_REQUEST",

    CLEAR_ACCOUNT_DATE: "accounts/CLEAR_ACCOUNT_DATE",
    CLEAR_MOVEMENTS_FILTERS: "accounts/CLEAR_MOVEMENTS_FILTERS",

    CASH_OUT_PREVIEW_REQUEST: "accounts/CASH_OUT_PREVIEW_REQUEST",
    CASH_OUT_PREVIEW_FAILURE: "accounts/CASH_OUT_PREVIEW_FAILURE",
    CASH_OUT_PREVIEW_SUCCESS: "accounts/CASH_OUT_PREVIEW_SUCCESS",
    CASH_OUT_SEND_REQUEST: "accounts/CASH_OUT_SEND_REQUEST",
    CASH_OUT_SEND_FAILURE: "accounts/CASH_OUT_SEND_FAILURE",
    CASH_OUT_SEND_SUCCESS: "accounts/CASH_OUT_SEND_SUCCESS",
    CLEAN_CASH_OUT: "accounts/CLEAN_CASH_OUT",

    DIRECT_DEBIT_UPLOAD_DOCUMENT_REQUEST: "accounts/DIRECT_DEBIT_UPLOAD_DOCUMENT_REQUEST",
    DIRECT_DEBIT_UPLOAD_DOCUMENT_FAILURE: "accounts/DIRECT_DEBIT_UPLOAD_DOCUMENT_FAILURE",
    DIRECT_DEBIT_UPLOAD_DOCUMENT_SUCCESS: "accounts/DIRECT_DEBIT_UPLOAD_DOCUMENT_SUCCESS",

    DIRECT_DEBIT_DELETE_DOC_REQUEST: "accounts/DIRECT_DEBIT_DELETE_DOC_REQUEST",
    DIRECT_DEBIT_DELETE_DOC_SUCCESS: "accounts/DIRECT_DEBIT_DELETE_DOC_SUCCESS",
    DIRECT_DEBIT_DELETE_DOC_FAILURE: "accounts/DIRECT_DEBIT_DELETE_DOC_FAILURE",

    DIRECT_DEBIT_DOWNLOAD_TEMPLATE_REQUEST: "accounts/DIRECT_DEBIT_DOWNLOAD_TEMPLATE_REQUEST",

    DIRECT_DEBIT_SEND_REQUEST: "accounts/DIRECT_DEBIT_SEND_REQUEST",
    DIRECT_DEBIT_SEND_SUCCESS: "accounts/DIRECT_DEBIT_SEND_SUCCESS",
    DIRECT_DEBIT_SEND_FAILURE: "accounts/DIRECT_DEBIT_SEND_FAILURE",

    DIRECT_DEBIT_CLEAN_REQUEST: "accounts/DIRECT_DEBIT_CLEAN_REQUEST",
    DIRECT_DEBIT_SET_UPLOAD_ERROR_REQUEST: "accounts/DIRECT_DEBIT_SET_UPLOAD_ERROR_REQUEST",
    DIRECT_DEBIT_SET_DOCCONFIRM_REQUEST: "accounts/DIRECT_DEBIT_SET_DOCCONFIRM_REQUEST",

    DIRECT_DEBIT_LIST_DOWNLOADS_REQUEST: "accounts/DIRECT_DEBIT_LIST_DOWNLOADS_REQUEST",
    DIRECT_DEBIT_LIST_DOWNLOADS_SUCCESS: "accounts/DIRECT_DEBIT_LIST_DOWNLOADS_SUCCESS",
    DIRECT_DEBIT_LIST_DOWNLOADS_FAILURE: "accounts/DIRECT_DEBIT_LIST_DOWNLOADS_FAILURE",

    DIRECT_DEBIT_GET_DOWNLOAD_REQUEST: "accounts/DIRECT_DEBIT_GET_DOWNLOAD_REQUEST",
    DIRECT_DEBIT_GET_DOWNLOAD_SUCCESS: "accounts/DIRECT_DEBIT_GET_DOWNLOAD_SUCCESS",
    DIRECT_DEBIT_GET_DOWNLOAD_FAILURE: "accounts/DIRECT_DEBIT_GET_DOWNLOAD_FAILURE",
};

export const INITIAL_STATE = {
    account: {}, // No encuentro que se utilice, dado que el detalle utiliza selectedAccount
    accounts: [],
    agreements: [],
    date: null,
    equivalentTotalBalance: null,
    fetching: false,
    fetchingAgreements: false,
    fetchingDownload: false,
    fetchingHistoricalBalances: false,
    fetchingMovements: false,
    fetchingQr: false,
    firstFetched: true,
    historicalBalances: [],
    historicalBalancesFetching: false,
    idSelectedAccount: null,
    mobileFilter: null,
    movements: [],
    moreMovements: false,
    qrCode: null,
    pageNumber: 1,
    selectedAccount: null,
    selectedFilter: null,
    selectedMovement: null,
    statements: null,
    voucher: null,
    isOptionsVisible: false,
    years: null,
    months: null,
    filters: {
        channels: [],
        check: null,
        dateFrom: null,
        dateTo: null,
        minAmount: null,
        maxAmount: null,
        reference: null,
        year: null,
        month: null,
        parentFilter: "lastMonth",
    },
    totalCount: 0,
    agreementAvailableAmount: {},
    agreementTax: 0,
    newAgreement: {},
    newAgreementShouldShowLastValues: false,
    newAgreementTicket: { status: "", idTransaction: "" },
    newAccountData: {},
    newAccountDataShouldShowLastValues: false,
    newAccountRequiredCredentials: [],
    newAccountTicket: { status: "", idTransaction: "" },
    newAccountTicketSignable: true,
    selectedAccountBalances: {},
    generateCashOutCodeInProgress: false,
    cashOutSendStatus: null,
    fetchingAlias: false,
    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null, fileId: 0 },
    externalUploadError: null,
    documentToConfirm: null,
    downloadsList: null,
    showAlert: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        account,
        accounts,
        agreements,
        alias,
        equivalentTotalBalance,
        totalBalanceARS,
        totalBalanceUSD,
        filters,
        historicalBalances,
        idSelectedAccount,
        mobileFilter,
        moreStatements,
        pageNumber,
        selectedMovement,
        statements,
        statementLines,
        totalCount,
        qrCode,
        agreementAvailableAmount,
        agreementTax,
        newAgreement,
        newAgreementShouldShowLastValues,
        newAgreementTicket,
        newAccountData,
        newAccountDataShouldShowLastValues,
        newAccountRequiredCredentials,
        newAccountTicket,
        newAccountTicketSignable,
        data,
        cbuAlias,
        cashOutSendStatus,
        documentToUploadRequest,
        documentCode,
        externalUploadError,
        documentToConfirm,
        directDebitDownloadsList,
        fileId,
        showAlert,
    } = action;

    switch (action.type) {
        case types.CLOSE_OPTIONS:
            return {
                ...state,
                isOptionsVisible: false,
            };
        case types.ACCOUNT_DETAILS_REQUEST:
            return {
                ...state,
                fetching: true,
                fetchingMovements: true,
                filters: filters || state.filters,
                movements: [],
                pageNumber: 1,
            };
        case types.ACCOUNT_DETAILS_SUCCESS:
            return {
                ...state,
                fetching: false,
                fetchingMovements: false,
                firstFetched: false,
                moreMovements: moreStatements,
                movements: data.movements,
                totalCount,
                showAlert,
            };
        case types.ACCOUNT_READ_REQUEST:
            return {
                ...state,
                isOptionsVisible: false,
                fetching: true,
                fetchingDownload: false,
                idSelectedAccount,
            };
        case types.ACCOUNT_READ_SUCCESS:
            return {
                ...state,
                fetching: false,
                selectedAccount: account,
            };
        case types.ACCOUNT_READ_QR_REQUEST:
            return {
                ...state,
                fetchingQr: true,
            };
        case types.ACCOUNT_READ_QR_SUCCESS:
            return {
                ...state,
                fetchingQr: false,
                qrCode,
            };
        case types.ACCOUNT_DOWNLOAD_STATEMENT_REQUEST:
            return { ...state, fetching: true };
        case types.ACCOUNT_DOWNLOAD_STATEMENT_SUCCESS:
            return { ...state, fetching: false };
        case types.ACCOUNT_FETCH_MORE_MOVEMENTS_REQUEST:
            return {
                ...state,
                fetchingMovements: true,
            };
        case types.ACCOUNT_FETCH_MORE_MOVEMENTS_SUCCESS:
            return {
                ...state,
                fetchingMovements: false,
                movements: state.movements ? state.movements.concat(statements) : statements,
                moreMovements: moreStatements,
                pageNumber,
                showAlert,
            };
        case types.ACCOUNT_MOVEMENT_DETAILS_REQUEST:
            return { ...state, fetching: true };
        case types.ACCOUNT_MOVEMENT_DETAILS_SUCCESS:
            return { ...state, fetching: false, selectedMovement };
        case types.LIST_ACCOUNT_STATEMENTS_REQUEST:
            return {
                ...state,
                fetchingMovements: true,
            };
        case types.LIST_ACCOUNT_STATEMENTS_SUCCESS:
            return {
                ...state,
                fetchingMovements: false,
                statements: statementLines,
            };
        case types.LIST_ACCOUNTS_REQUEST:
        case types.LIST_ALL_ACCOUNTS_REQUEST:
            return {
                ...state,
                fetching: true,
                moreMovements: false,
                agreements: [],
                selectedMovement: null,
                historicalBalances: [],
                pageNumber: 1,
            };
        case types.LIST_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accounts,
                totalBalanceUSD,
                totalBalanceARS,
                fetching: false,
                isOptionsVisible: false,
            };
        case types.LIST_ACCOUNTS_FAILURE:
            return {
                ...state,
                fetching: false,
                moreMovements: false,
                agreements: [],
                selectedMovement: null,
                historicalBalances: [],
                pageNumber: 1,
            };
        case types.LIST_ACCOUNTS_CBU_REQUEST:
            return {
                ...state,
                fetching: true,
                movements: [],
                moreMovements: false,
                agreements: [],
                selectedMovement: null,
                historicalBalances: [],
                pageNumber: 1,
            };
        case types.LIST_ACCOUNTS_CBU_SUCCESS:
            return {
                ...state,
                accounts,
                totalBalanceUSD,
                totalBalanceARS,
                fetching: false,
                isOptionsVisible: false,
            };

        case types.RESET_FILTERS:
            return { ...state, filters: INITIAL_STATE.filters };
        case types.SET_MOBILE_FILTER:
            return {
                ...state,
                mobileFilter,
            };
        case types.SET_SELECTED_MOVEMENT:
            return {
                ...state,
                selectedMovement,
            };
        case types.SET_UNIQUE_ACCOUNT:
            return {
                ...state,
                accounts,
                equivalentTotalBalance,
                selectedAccount: accounts[0],
            };

        case types.TOGGLE_OPTIONS: {
            return {
                ...state,
                isOptionsVisible: !state.isOptionsVisible,
            };
        }

        case productsTypes.CHANGE_PRODUCT_ALIAS_SUCCESS: {
            return {
                ...state,
                selectedAccount: {
                    ...state.selectedAccount,
                    productAlias: alias,
                },
            };
        }
        case types.DOWNLOAD_HISTORICAL_BALANCES_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_HISTORICAL_BALANCES_FAILURE:
        case types.DOWNLOAD_HISTORICAL_BALANCES_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_MOVEMENTS_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_MOVEMENTS_FAILURE:
        case types.DOWNLOAD_MOVEMENTS_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_PENDING_MOVEMENTS_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_PENDING_MOVEMENTS_FAILURE:
        case types.DOWNLOAD_PENDING_MOVEMENTS_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_ACCOUNTS_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_ACCOUNTS_FAILURE:
        case types.DOWNLOAD_ACCOUNTS_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };

        case types.ACCOUNT_FETCH_MOVEMENTS_REQUEST:
            return {
                ...state,
                pageNumber: 1,
                filters: action.filters,
                fetchingMovements: true,
            };
        case types.ACCOUNT_FETCH_MOVEMENTS_SUCCESS:
            return {
                ...state,
                fetchingMovements: false,
                movements: action.statements,
                moreMovements: action.moreStatements,
                totalCount: action.totalCount,
                showAlert,
            };
        case types.ACCOUNT_FETCH_MOVEMENTS_STATES_REQUEST:
            return {
                ...state,
                fetchingMovements: true,
                movements: action.data,
            };
        case types.ACCOUNT_FETCH_MOVEMENTS_STATES_SUCCESS:
            return {
                ...state,
                fetchingMovements: false,
                movements: action.data,
            };
        case types.ACCOUNT_AGREEMENTS_SUCCESS:
            return {
                ...state,
                agreements,
                fetchingAgreements: false,
            };
        case types.ACCOUNT_AGREEMENTS_REQUEST:
            return {
                ...state,
                fetchingAgreements: true,
            };
        case types.AGREEMENT_AVAILABLE_AMOUNT_REQUEST:
            return {
                ...state,
                fetchingAgreements: true,
            };
        case types.AGREEMENT_AVAILABLE_AMOUNT_SUCCESS:
            return {
                ...state,
                agreementAvailableAmount,
                fetchingAgreements: false,
            };
        case types.AGREEMENT_TAX_REQUEST:
            return {
                ...state,
                fetchingAgreements: true,
            };
        case types.AGREEMENT_TAX_SUCCESS:
            return {
                ...state,
                agreementTax,
                fetchingAgreements: false,
            };
        case types.NEW_AGREEMENT_TICKET_REQUEST:
            return {
                ...state,
                newAgreementTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_AGREEMENT_TICKET_SUCCESS:
            return {
                ...state,
                newAgreementTicket,
            };
        case types.CLEAN_NEW_AGREEMENT_TICKET:
            return {
                ...state,
                newAgreementTicket: { status: "", idTransaction: "" },
            };
        case types.CLEAN_ACCOUNT_MOVEMENTS:
            return {
                ...state,
                movements: [],
            };
        case types.ACCOUNT_SUMMARY_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    year: action.filters.year,
                    month: action.filters.month,
                },
            };
        case types.MOVEMENTS_SUMMARY_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...filters,
                },
            };
        case types.CLEAR_MOVEMENTS_FILTERS:
            return {
                ...state,
                filters: {
                    ...INITIAL_STATE.filters,
                },
            };
        case types.ACCOUNT_GET_YEARS_MONTH_SUMMARY_REQUEST:
            return {
                ...state,
                fetchingMovements: true,
            };
        case types.ACCOUNT_GET_YEARS_MONTH_SUMMARY_SUCCESS:
            return {
                ...state,
                fetchingMovements: false,
                years: action.years,
                months: action.months,
            };
        case types.SET_NEW_AGREEMENT:
            return {
                ...state,
                newAgreement,
            };
        case types.NEW_AGREEMENT_SHOW:
            return {
                ...state,
                newAgreementShouldShowLastValues,
            };
        case types.SET_NEW_ACCOUNT_DATA:
            return {
                ...state,
                newAccountData,
            };
        case types.ACCOUNT_TICKET_CREDENTIAL_SUCCESS:
            return {
                ...state,
                fetching: false,
                newAccountRequiredCredentials,
                newAccountTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_ACCOUNT_DATA_SHOW:
            return {
                ...state,
                newAccountDataShouldShowLastValues,
            };
        case types.NEW_ACCOUNT_TICKET_REQUEST:
            return {
                ...state,
                newAccountTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_ACCOUNT_TICKET_SUCCESS:
            return {
                ...state,
                newAccountTicket,
                newAccountTicketSignable: !(newAccountTicket.status !== "INVALID_CREDENTIAL"),
            };
        case types.CLEAN_NEW_ACCOUNT_TICKET:
            return {
                ...state,
                newAccountTicket: { status: "", idTransaction: "" },
                newAccountTicketSignable: true,
            };
        case types.SET_NEW_ACCOUNT_SIGNING:
            return {
                ...state,
                newAccountTicketSignable,
            };
        case types.SIGN_ACCOUNT_TICKET_REQUEST:
            return {
                ...state,
                newAccountTicket: { status: "", idTransaction: "" },
            };
        case types.SIGN_ACCOUNT_TICKET_SUCCESS:
            return {
                ...state,
                newAccountTicket,
            };
        case types.ACCOUNT_HISTORICAL_BALANCES_SUCCESS:
            return {
                ...state,
                historicalBalances,
                historicalBalancesFetching: false,
                date: action.date,
            };
        case types.ACCOUNT_HISTORICAL_BALANCES_REQUEST:
            return {
                ...state,
                historicalBalancesFetching: true,
            };
        case types.ACCOUNT_HISTORICAL_BALANCES_FAILURE:
            return {
                ...state,
                fetchinHistoricalBalances: false,
            };
        case types.CHANGE_CBU_ALIAS_SUCCESS:
            return {
                ...state,
                selectedAccount: {
                    ...state.selectedAccount,
                    alias: cbuAlias,
                    cbuAlias,
                },
                fetchingAlias: false,
            };
        case types.CHANGE_CBU_ALIAS_REQUEST:
            return {
                ...state,
                fetchingAlias: true,
            };
        case types.CHANGE_CBU_ALIAS_FAILURE:
            return {
                ...state,
                fetchingAlias: false,
            };
        case types.CLEAR_ACCOUNT_DATE:
            return {
                ...state,
                date: null,
            };
        default:
            return state;
        case types.DOWNLOAD_MOVEMENT_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_MOVEMENT_FAILURE:
        case types.DOWNLOAD_MOVEMENT_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.FILTER_BALANCES_REQUEST:
            // eslint-disable-next-line no-case-declarations
            const { totalBalance, availableBalance, proyectedOverdraftBalance, pendingBalance } = account;
            // eslint-disable-next-line no-case-declarations
            const selectedAccountBalances = {
                totalBalance,
                availableBalance,
                proyectedOverdraftBalance,
                pendingBalance,
            };
            return {
                ...state,
                selectedAccountBalances,
            };
        case types.CASH_OUT_SEND_REQUEST:
            return {
                ...state,
                generateCashOutCodeInProgress: true,
                cashOutSendStatus: null,
            };
        case types.CASH_OUT_SEND_FAILURE:
        case types.CLEAN_CASH_OUT:
            return {
                ...state,
                generateCashOutCodeInProgress: false,
                cashOutSendStatus: null,
            };
        case types.CASH_OUT_SEND_SUCCESS:
            return {
                ...state,
                generateCashOutCodeInProgress: false,
                cashOutSendStatus,
            };
        case types.CASH_OUT_PREVIEW_REQUEST:
            return {
                ...state,
                generateCashOutCodeInProgress: true,
            };
        case types.CASH_OUT_PREVIEW_FAILURE:
            return {
                ...state,
                generateCashOutCodeInProgress: false,
                cashOutSendStatus: false,
            };
        case types.CASH_OUT_PREVIEW_SUCCESS:
            return {
                ...state,
                generateCashOutCodeInProgress: false,
                cashOutSendStatus: true,
            };
        case types.DIRECT_DEBIT_UPLOAD_DOCUMENT_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "FETCHING", value: "", error: null, id: documentCode, fileId: 0 },
            };
        case types.DIRECT_DEBIT_UPLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "SUCCESS",
                    value: documentToUploadRequest,
                    error: null,
                    id: documentCode,
                    fileId,
                },
            };
        case types.DIRECT_DEBIT_UPLOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "FAILURE",
                    value: "",
                    error: null,
                    id: null,
                    fileId: 0,
                },
            };
        case types.DIRECT_DEBIT_DELETE_DOC_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null, fileId: 0 },
            };
        case types.DIRECT_DEBIT_SEND_REQUEST:
            return {
                ...state,
            };
        case types.DIRECT_DEBIT_DELETE_DOC_FAILURE:
        case types.DIRECT_DEBIT_SEND_SUCCESS:
            return {
                ...state,
            };
        case types.DIRECT_DEBIT_CLEAN_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null, fileId: 0 },
                externalUploadError: null,
            };
        case types.DIRECT_DEBIT_SET_UPLOAD_ERROR_REQUEST:
            return {
                ...state,
                externalUploadError,
            };
        case types.DIRECT_DEBIT_SET_DOCCONFIRM_REQUEST:
            return {
                ...state,
                documentToConfirm,
            };
        case types.DIRECT_DEBIT_LIST_DOWNLOADS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DIRECT_DEBIT_LIST_DOWNLOADS_SUCCESS:
            return {
                ...state,
                directDebitDownloadsList,
                fetching: false,
            };
        case types.DIRECT_DEBIT_LIST_DOWNLOADS_FAILURE:
            return {
                ...state,
                fetching: false,
                directDebitDownloadsList: null,
            };
        case types.DIRECT_DEBIT_GET_DOWNLOAD_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DIRECT_DEBIT_GET_DOWNLOAD_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.DIRECT_DEBIT_GET_DOWNLOAD_FAILURE:
            return {
                ...state,
                fetching: false,
            };
    }
};

export const actions = {
    agreements: (idAccount, date) => ({
        type: types.ACCOUNT_AGREEMENTS_REQUEST,
        idAccount,
        date,
    }),
    closeOptions: () => ({
        type: types.CLOSE_OPTIONS,
    }),
    yearsMonthRequest: () => ({
        type: types.ACCOUNT_GET_YEARS_MONTH_SUMMARY_REQUEST,
    }),
    setYearMonthFilter: (filters) => ({
        type: types.ACCOUNT_SUMMARY_FILTER,
        filters,
    }),
    setFilterMovements: (filters) => ({
        type: types.MOVEMENTS_SUMMARY_FILTER,
        filters,
    }),
    details: (idSelectedAccount, filters, formikBag) => ({
        type: types.ACCOUNT_DETAILS_REQUEST,
        idSelectedAccount,
        filters,
        formikBag,
    }),
    downloadHistoricalBalances: (idProduct, date, format) => ({
        type: types.DOWNLOAD_HISTORICAL_BALANCES_REQUEST,
        idProduct,
        date,
        format,
    }),
    downloadMovements: (idAccount, format) => ({
        type: types.DOWNLOAD_MOVEMENTS_REQUEST,
        idAccount,
        format,
    }),
    downloadPendingMovements: ({ idAccount, dateFrom, dateTo }, format) => ({
        type: types.DOWNLOAD_PENDING_MOVEMENTS_REQUEST,
        idAccount,
        dateFrom,
        dateTo,
        format,
    }),
    downloadAccounts: (format) => ({
        type: types.DOWNLOAD_ACCOUNTS_REQUEST,
        format,
    }),
    downloadStatement: (idStatement) => ({
        type: types.ACCOUNT_DOWNLOAD_STATEMENT_REQUEST,
        idStatement,
    }),
    editMovementNote: (accountId, movementId, note) => ({
        type: types.EDIT_MOVEMENT_NOTE_REQUEST,
        accountId,
        movementId,
        note,
    }),
    fetchMoreMovements: (accountId, filters) => ({
        type: types.ACCOUNT_FETCH_MORE_MOVEMENTS_REQUEST,
        accountId,
        filters,
    }),

    historicalBalances: (idAccount, date) => ({
        type: types.ACCOUNT_HISTORICAL_BALANCES_REQUEST,
        idAccount,
        date,
    }),
    listAccounts: () => ({
        type: types.LIST_ACCOUNTS_REQUEST,
    }),
    listAllAccounts: () => ({
        type: types.LIST_ALL_ACCOUNTS_REQUEST,
    }),
    listAccountsCbu: () => ({
        type: types.LIST_ACCOUNTS_CBU_REQUEST,
    }),
    listStatements: (year, month, accountId) => ({
        type: types.LIST_ACCOUNT_STATEMENTS_REQUEST,
        year,
        month,
        accountId,
    }),
    movementDetails: (idAccount) => ({
        type: types.ACCOUNT_MOVEMENT_DETAILS_REQUEST,
        idAccount,
    }),
    readAccount: (idAccount, getPendingBalance) => ({
        type: types.ACCOUNT_READ_REQUEST,
        idAccount,
        getPendingBalance,
    }),
    readAccountQr: (idAccount) => ({
        type: types.ACCOUNT_READ_QR_REQUEST,
        idAccount,
    }),
    resetFilters: () => ({
        type: types.RESET_FILTERS,
    }),
    setMobileFilter: (mobileFilter) => ({
        type: types.SET_MOBILE_FILTER,
        mobileFilter,
    }),
    setSelectedMovement: (selectedMovement) => ({
        type: types.SET_SELECTED_MOVEMENT,
        selectedMovement,
    }),
    toggleOptions: () => ({
        type: types.TOGGLE_OPTIONS,
    }),
    fetchMovements: (accountId, filters) => ({
        type: types.ACCOUNT_FETCH_MOVEMENTS_REQUEST,
        accountId,
        filters,
    }),
    fetchMovementsState: (accountId, state) => ({
        type: types.ACCOUNT_FETCH_MOVEMENTS_STATES_REQUEST,
        accountId,
        state,
    }),
    fetchAgreementAvailableAmount: () => ({
        type: types.AGREEMENT_AVAILABLE_AMOUNT_REQUEST,
    }),
    fetchAgreementTax: (currency, deadline, amount) => ({
        type: types.AGREEMENT_TAX_REQUEST,
        currency,
        deadline,
        amount,
    }),
    setNewAgreement: (newAgreement) => ({
        type: types.SET_NEW_AGREEMENT,
        newAgreement,
    }),
    newAgreementShouldShowLastValues: (newValue) => ({
        type: types.NEW_AGREEMENT_SHOW,
        newAgreementShouldShowLastValues: newValue,
    }),
    setNewAgreementCredential: (newAgreement, formikBag, credentialType) => ({
        type: types.NEW_AGREEMENT_TICKET_REQUEST,
        newAgreement,
        formikBag,
        credentialType,
    }),
    cleanNewAgreementTicket: () => ({
        type: types.CLEAN_NEW_AGREEMENT_TICKET,
    }),
    setNewAccountData: (newAccountData) => ({
        type: types.SET_NEW_ACCOUNT_DATA,
        newAccountData,
    }),
    fetchCredentialGroup: () => ({
        type: types.ACCOUNT_TICKET_CREDENTIAL_REQUEST,
    }),
    newAccountDataShouldShowLastValues: (newValue) => ({
        type: types.NEW_ACCOUNT_DATA_SHOW,
        newAccountDataShouldShowLastValues: newValue,
    }),
    setNewAccountCredential: (newAccountData) => ({
        type: types.NEW_ACCOUNT_TICKET_REQUEST,
        newAccountData,
    }),
    signAccountTransaction: (signParams) => ({
        type: types.SIGN_ACCOUNT_TICKET_REQUEST,
        signParams,
    }),
    cleanNewAccountTicket: () => ({
        type: types.CLEAN_NEW_ACCOUNT_TICKET,
    }),
    setNewAccountTicketSignable: (newValue) => ({
        type: types.SET_NEW_ACCOUNT_SIGNING,
        newAccountTicketSignable: newValue,
    }),
    changeCbuAlias: (idAccount, cbu, newAlias, password, formikBag, toggleSidebar) => ({
        type: types.CHANGE_CBU_ALIAS_REQUEST,
        idAccount,
        cbu,
        newAlias,
        password,
        formikBag,
        toggleSidebar,
    }),
    cleanAccountMovements: () => ({
        type: types.CLEAN_ACCOUNT_MOVEMENTS,
    }),
    downloadMovement: (movement, format) => ({
        type: types.DOWNLOAD_MOVEMENT_REQUEST,
        movement,
        format,
    }),
    filterBalances: (account) => ({
        type: types.FILTER_BALANCES_REQUEST,
        account,
    }),
    setAccountDate: () => ({
        type: types.CLEAR_ACCOUNT_DATE,
    }),
    clearMovementsFilters: () => ({
        type: types.CLEAR_MOVEMENTS_FILTERS,
    }),
    cashOutPreview: (params) => ({
        type: types.CASH_OUT_PREVIEW_REQUEST,
        params,
    }),
    cashOutSend: (params, formikBag) => ({
        type: types.CASH_OUT_SEND_REQUEST,
        params,
        formikBag,
    }),
    cleanCashOut: () => ({
        type: types.CLEAN_CASH_OUT,
    }),
    directDebitRequest: (documentToUpload) => ({
        type: types.DIRECT_DEBIT_UPLOAD_DOCUMENT_REQUEST,
        documentToUpload,
        documentCode: documentToUpload.uploaderRequestId,
    }),
    directDebitDocumentDelete: (fileId) => ({
        type: types.DIRECT_DEBIT_DELETE_DOC_REQUEST,
        fileId,
    }),
    downloadTemplate: () => ({
        type: types.DIRECT_DEBIT_DOWNLOAD_TEMPLATE_REQUEST,
    }),
    directDebitSend: (params, formikBag) => ({
        type: types.DIRECT_DEBIT_SEND_REQUEST,
        params,
        formikBag,
    }),
    directDebitClean: () => ({
        type: types.DIRECT_DEBIT_CLEAN_REQUEST,
    }),
    setDirectDebitUploadError: (externalUploadError) => ({
        type: types.DIRECT_DEBIT_SET_UPLOAD_ERROR_REQUEST,
        externalUploadError,
    }),
    setDocumentToConfirm: (documentToConfirm) => ({
        type: types.DIRECT_DEBIT_SET_DOCCONFIRM_REQUEST,
        documentToConfirm,
    }),
    listDirectDebitDownloads: (params) => ({
        type: types.DIRECT_DEBIT_LIST_DOWNLOADS_REQUEST,
        params,
    }),
    getDirectDebitDownload: (params) => ({
        type: types.DIRECT_DEBIT_GET_DOWNLOAD_REQUEST,
        params,
    }),
};

export const selectors = {
    getAccount: ({ accounts }) => accounts.account,
    getAccounts: ({ accounts }) => accounts.accounts,
    getAgreements: ({ accounts }) => accounts.agreements,
    getTotalAccounts: ({ accounts }) => accounts.accounts.length,
    getTotalAgreements: ({ accounts }) => accounts.agreements.length,
    getTotalBalanceUSD: ({ accounts }) => accounts.totalBalanceUSD,
    getTotalBalanceARS: ({ accounts }) => accounts.totalBalanceARS,
    getDate: ({ accounts }) => accounts.date,
    getEquivalentTotalBalance: ({ accounts }) => accounts.equivalentTotalBalance,
    getFetching: ({ accounts }) => accounts.fetching,
    getFetchingAgreements: ({ accounts }) => accounts.fetchingAgreements,
    getFetchingDownload: ({ accounts }) => accounts.fetchingDownload,
    getFetchingMovements: ({ accounts }) => accounts.fetchingMovements,
    getFetchingQr: ({ accounts }) => accounts.fetchingQr,
    getFetchingAlias: ({ accounts }) => accounts.fetchingAlias,
    getFilters: ({ accounts }) => accounts.filters,
    getFirstFetched: ({ accounts }) => accounts.firstFetched,
    getHistoricalBalances: ({ accounts }) => accounts.historicalBalances,
    getHistoricalBalancesFetching: ({ accounts }) => accounts.historicalBalancesFetching,
    getIdSelectedAccount: ({ accounts }) => accounts.idSelectedAccount,
    getIsOptionsVisible: ({ accounts }) => accounts.isOptionsVisible,
    getSelectedAccount: ({ accounts }) => accounts.selectedAccount,
    getSelectedFilter: ({ accounts }) => accounts.selectedFilter,
    getSelectedMovement: ({ accounts }) => accounts.selectedMovement,
    getStatements: ({ accounts }) => accounts.statements,
    getPageNumber: ({ accounts }) => accounts.pageNumber,
    getMobileFilter: ({ accounts }) => accounts.mobileFilter,
    getMoreMovements: ({ accounts }) => accounts.moreMovements,
    getMovements: ({ accounts }) => accounts.movements,
    getVoucher: ({ accounts }) => accounts.voucher,
    getTotalCount: ({ accounts }) => accounts.totalCount,
    getYears: ({ accounts }) => accounts.years,
    getMonths: ({ accounts }) => accounts.months,
    getQrCode: ({ accounts }) => accounts.qrCode,
    getNewAccountData: ({ accounts }) => accounts.newAccountData,
    getNewAccountDataShouldShowLastValues: ({ accounts }) => accounts.newAccountDataShouldShowLastValues,
    getNewAccountRequiredCredentials: ({ accounts }) => accounts.newAccountRequiredCredentials,
    getNewAccountTicketStatus: ({ accounts }) => accounts.newAccountTicket?.status,
    getNewAccountTicketId: ({ accounts }) => accounts.newAccountTicket?.idTransaction,
    getNewAccountTicket: ({ accounts }) => accounts.newAccountTicket,
    getNewAccountTicketSignable: ({ accounts }) => accounts.newAccountTicketSignable,
    getSelectedAccountBalances: ({ accounts }) => accounts.selectedAccountBalances,
    getGenerateCashOutCodeInProgress: ({ accounts }) => accounts.generateCashOutCodeInProgress,
    getCashOutSendStatus: ({ accounts }) => accounts.cashOutSendStatus,
    getDocumentToConfirm: ({ accounts }) => accounts.documentToConfirm,
    getDirectDebitDownloadsList: ({ accounts }) => accounts.directDebitDownloadsList,
    getDirectDebitFileId: ({ accounts }) => accounts.documentToUploadRequest.fileId,
    getShowAlert: ({ accounts }) => accounts.showAlert,
};
